import React, {Component} from 'react';

import {CenteredContainer} from './styles';

class Container extends Component {
  render() {
    const {children, className, noPaddingLeft} = this.props;

    return (
      <CenteredContainer noPaddingLeft={noPaddingLeft} className={className}>
        {children}
      </CenteredContainer>
    );
  }
}

export default Container;
